import React from 'react';
import { Outlet } from 'react-router-dom';
import { useSurvey } from '../api/Surveys';
import Loading from '../components/Loading';
import { SurveyProcessingType, SurveyStatus } from '../constants';
import useParams from '../hooks/useParams';
import useSuperuser from '../hooks/useSuperuser';
import NotFound from '../pages/NotFound';

function ThemeEngineRoute() {
  const { surveyId } = useParams();
  const { data: survey, isLoading: surveyLoading } = useSurvey({ surveyId });
  const { isSuperuser, isLoading: superuserLoading } = useSuperuser();

  const isProSurvey = survey?.data.processing_type === SurveyProcessingType.PRO;

  const hasSurveyAccess = () => {
    // SuperAdmin users have access to all surveys
    if (isSuperuser) {
      return true;
    }

    return (
      isProSurvey ||
      survey.data.survey_status === SurveyStatus.PUBLISHED ||
      survey.data.survey_status === SurveyStatus.PUBLISH_IN_PROGRESS
    );
  };

  if (surveyLoading || superuserLoading) {
    return <Loading />;
  }

  return hasSurveyAccess() ? <Outlet /> : <NotFound />;
}

export default ThemeEngineRoute;
